import React from 'react';

export default function Empty() {
  return (
    <div className="row">
      <div className="col s12 m12">
      </div>
    </div>
  );
}
